'use strict';

export class PaofferPaoffer {
	constructor(component_key) {
		this.id = component_key;
		this.component = yalwa.v.components[component_key];
		this.data = {};
		this.send_data = {};
		this.api = '';
		this.action = '';
		

		const initialTime = Number(yalwa.v.components.paoffer_paoffer.time_left);
		this.endTime = (initialTime + 3600) * 1000;
		
		this.time_left_label = yalwa.v.components.paoffer_paoffer.time_left_label;
		this.$root = jQuery(`body .js-${this.id}`);
		this.$label_target = jQuery('.js-offer_ts_label');
		

		this.update_time_left = this.update_time_left.bind(this);
	}
	
	init() {
		this.init_offer_ts();
		if (yalwa.v.components.paoffer_paoffer.touchpoint != 'account_upgrade_page') {
			jQuery('.js-pa_offer_url').on('click', function() {
				const url = jQuery(this).data('url');
				yalwa.basics.navigate(url);
			});
		}
		
	}

	init_offer_ts() {
		this.update_time_left();
		this.update_time_left();
	}

	update_time_left() {
		const now = Date.now();
		const diff = this.endTime - now; 
		

		if (diff <= 0) {
			jQuery('.js-pa_offer').remove();
			jQuery('.js-pa_offer_active').remove();
			return;
		}

		const totalSeconds = Math.floor(diff / 1000);

		const minutes = Math.floor((totalSeconds % 3600) / 60);
		const seconds = totalSeconds % 60;


		const formattedMinutes = String(Math.max(0, minutes)).padStart(2, '0');
		const formattedSeconds = String(Math.max(0, seconds)).padStart(2, '0');
		this.$label_target.html(this.time_left_label.replace('%1$s', formattedMinutes).replace('%2$s', formattedSeconds));
		setTimeout(this.update_time_left, 1000);
	}
}

Object.keys(yalwa.v.components).forEach(component_key => {
	if (component_key.startsWith('paoffer_')) {
		new PaofferPaoffer(component_key).init();
	}
});